import { SlideMobileCommunityCardFacebookStyled } from "./styled/SlideMobileCommunityCardsStyled";

export const FacebookBanner = () => (
    <SlideMobileCommunityCardFacebookStyled>
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7910_107790)">
                <circle cx="20.75" cy="20" r="20" fill="#465F96" />
                <path d="M25.7744 19.9773H22.4523V31.1988H17.4192V19.9773H15.0254V16.0335H17.4192V13.4815C17.4192 11.6565 18.3594 8.79883 22.4971 8.79883L26.2254 8.81321V12.6412H23.5203C23.0766 12.6412 22.4527 12.8457 22.4527 13.7162V16.0372H26.2141L25.7744 19.9773Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_7910_107790">
                    <rect width="40" height="40" fill="white" transform="translate(0.75)" />
                </clipPath>
            </defs>
        </svg>
        <div>Facebook</div>
    </SlideMobileCommunityCardFacebookStyled>
);
